export default __webpack_public_path__ + "static/media/sol-hero.badbce56.gif";